import React from "react";
import {observer} from "mobx-react";

import "./documents-tab-pane.scss";

import {Kiwis, Station} from "../../../../../kiwis";
import {StationDocument} from "./station-document/station-document";
import {Header, Message, Tab, Table} from "semantic-ui-react";

const Placeholder = (props: any) => (
    <Tab.Pane
        key={`documents-pane-${props.stationId}`}
        className={"documents-tab-pane"}
        active={props.active}
    >
        <Message
            className="documents-no-data-message"
            icon="eye slash outline"
            header="Keine Daten verfügbar"
            content={props.placeholderText}
        />
    </Tab.Pane>
);

const StationInfoTableRow = (props: any) => (
    <Table.Row className={`geo-station-pane-table-row ${props.hideLabel && "borderless"}`}
        key={`station-table-row-${props.name}`}>
        <Table.Cell><Header as="h4" content={props.label}/></Table.Cell>
        <Table.Cell>{props.value}</Table.Cell>
    </Table.Row>
);

const DocumentTableRow = (props: any) => (
    <StationInfoTableRow
        key={`station-info-table-row-${props.url}`}
        label={!props.hideLabel && props.label}
        hideLabel={props.hideLabel}
        value={
            <StationDocument
                key={props.url}
                url={props.url}
            />
        }
        stationId={props.stationId}
    />
);

interface DocumentsTabPaneProps {
    station: Station;
    kiwis: Kiwis;
    active: boolean; // is tab active
}

@observer
export class DocumentsTabPane extends React.Component<DocumentsTabPaneProps, any> {
    constructor(props: DocumentsTabPaneProps) {
        super(props);
        this.state = {
            placeholderText: "Für diese Station sind keine Dokumente verfügbar."
        };
    }

    render() {
        const {active, kiwis, station} = this.props;
        if (!active) {
            return null;
        }

        const documents = kiwis.stationDocuments.get(this.props.station.no);
        if (!documents) {
            return <Placeholder
                placeholderText={this.state.placeholderText}
                active={active}
            />;
        }

        const documentData = documents.getDocumentData(
            kiwis.config.stationDocumentsConfig,
            kiwis.config.stationDocumentsBaseUrl
        );
        if (!documentData.length) {
            return <Placeholder
                placeholderText={this.state.placeholderText}
                active={active}
            />;
        }

        const docRows = documentData.map((document: any) =>
            <DocumentTableRow
                key={document.url}
                label={document.label}
                url={document.url}
                hideLabel={!document.isFirstOfCategory}
            />
        );

        return (
            <Tab.Pane
                key={`documents-pane-${station.id}`}
                className={"documents-tab-pane scrollable-content"}
                active={active}
            >
                <Table basic="very" celled collapsing unstackable className={"geo-station-pane-table"}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Kategorie</Table.HeaderCell>
                            <Table.HeaderCell>Link</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {docRows}
                    </Table.Body>
                </Table>
            </Tab.Pane>
        );
    }
}
